import { isProductReadinessEnabled } from "@/utils/accountProductFlags";

/** Roles / responsibilities UI on positions (tabs, counters, validity) follows product Readiness. */
export function isPositionRolesAndResponsibilitiesUiEnabled() {
  return isProductReadinessEnabled();
}

const ATTACHED_ROLES_TAB_LABEL = "Attached Roles and Responsibilities";
const ATTACHED_ROLES_ONLY_TAB_LABEL = "Attached roles";

/**
 * @param {boolean} showAttachedRolesTab
 * @param {boolean} ideaMdp585Enabled
 * @returns {string[]}
 */
export function buildPositionTabRouteValues(showAttachedRolesTab, ideaMdp585Enabled = false) {
  if (!showAttachedRolesTab) {
    return ["purpose", "assignments"];
  }
  return ["purpose", "attached-roles", "assignments"];
}

/**
 * @param {string|null|undefined} tabParam
 * @param {boolean} showAttachedRolesTab
 * @returns {{ index: number, redirectTo: string|null }}
 */
export function resolvePositionTabIndexFromRoute(tabParam, showAttachedRolesTab) {
  const defaultIndex = showAttachedRolesTab ? 1 : 0;
  if (tabParam == null || tabParam === "") {
    return { index: defaultIndex, redirectTo: showAttachedRolesTab ? null : "purpose" };
  }
  const normalized = String(tabParam).toLowerCase();
  if (normalized === "attached-roles" && !showAttachedRolesTab) {
    return { index: 0, redirectTo: "purpose" };
  }
  const routeValues = buildPositionTabRouteValues(showAttachedRolesTab);
  const index = routeValues.indexOf(normalized);
  if (index >= 0) {
    return { index, redirectTo: null };
  }
  return { index: defaultIndex, redirectTo: showAttachedRolesTab ? null : "purpose" };
}

/**
 * @param {number} tabIndex
 * @param {boolean} showAttachedRolesTab
 * @returns {string}
 */
export function positionTabIndexToRouteValue(tabIndex, showAttachedRolesTab) {
  const routeValues = buildPositionTabRouteValues(showAttachedRolesTab);
  return routeValues[tabIndex] ?? (showAttachedRolesTab ? "attached-roles" : "purpose");
}

/**
 * Menu label -> form tab index (PositionPageMenu).
 * @param {boolean} showAttachedRolesTab
 * @param {boolean} ideaMdp585Enabled
 */
export function buildPositionPageMenuLabelToIndex(showAttachedRolesTab, ideaMdp585Enabled = false) {
  const attachedLabel = ideaMdp585Enabled
    ? ATTACHED_ROLES_TAB_LABEL
    : ATTACHED_ROLES_ONLY_TAB_LABEL;
  if (!showAttachedRolesTab) {
    return {
      Context: 0,
      [ATTACHED_ROLES_TAB_LABEL]: 0,
      "Attached Roles": 0,
      [ATTACHED_ROLES_ONLY_TAB_LABEL]: 0,
      "History of Assignments": 1,
    };
  }
  return {
    Context: 0,
    [ATTACHED_ROLES_TAB_LABEL]: 1,
    "Attached Roles": 1,
    [ATTACHED_ROLES_ONLY_TAB_LABEL]: 1,
    "History of Assignments": 2,
  };
}

export function attachedRolesTabLabelForFlags(ideaMdp585Enabled) {
  return ideaMdp585Enabled ? ATTACHED_ROLES_TAB_LABEL : ATTACHED_ROLES_ONLY_TAB_LABEL;
}
